import { ReactNode } from 'react';

/**
 * מכל התוכן של כל מסכי ה-Layout.
 *
 * main ולא section: זהו התוכן הראשי של העמוד, וזה מה שהופך את "דילוג
 * לתוכן הראשי" ואת החזרת המיקוד במעבר עמוד לאפשריים. tabindex="-1" נדרש
 * כדי שאלמנט לא-אינטראקטיבי יוכל לקבל מיקוד תכנותי.
 */
function FrameSection({ children }: { children: ReactNode }) {
  return (
    <main id="main-content" tabIndex={-1} className="frame-section">
      {children}
    </main>
  );
}

export default FrameSection;
